import {IPlaylistMedia} from '@interfaces/playlist';
import {IDeviceArea} from '@interfaces/devices';

export class FetchScheduledGroups {
  static readonly type = '[Schedule] Fetch scheduled groups';

  constructor(public params?: {
    order?: string
  }) {
  }
}

export class FetchScheduledDevices {
  static readonly type = '[Schedule] Fetch scheduled devices';

  constructor(public params?: {
    order?: string
  }) {
  }
}

export class GetScheduledGroups {
  static readonly type = '[Schedule] Get scheduled groups';

  constructor() {
  }
}

export class GetScheduledDevices {
  static readonly type = '[Schedule] Get schedule devices';

  constructor() {
  }
}

export class SetCurrentScheduledDevicesPage {
  static readonly type = '[Schedule] Set devices current page';

  constructor(public page: number) {
  }
}

export class ChangeCurrentScheduledDevicesPage {
  static readonly type = '[Schedule] Change devices current page';

  constructor(public page: number) {
  }
}

export class SetCurrentScheduledGroupsPage {
  static readonly type = '[Schedule] Set groups current page';

  constructor(public page: number) {
  }
}

export class ChangeCurrentScheduledGroupsPage {
  static readonly type = '[Schedule] Change groups current page';

  constructor(public page: number) {
  }
}


export class SearchScheduledDevices {
  static readonly type = '[Schedule] Search scheduled devices';

  constructor(public searchParam: string) {
  }
}

export class SearchScheduledGroups {
  static readonly type = '[Schedule] Search scheduled groups';

  constructor(public searchParam: string) {
  }
}

export class SetActiveTab {
  static readonly type = '[Schedule] Set active tab';

  constructor(public tab: 'group' | 'device') {
  }
}

export class GroupToScheduleCreate {
  static readonly type = '[Schedule] Set group to schedule create object';

  constructor(public group: number, public name: string) {
  }
}

export class DeviceToScheduleCreate {
  static readonly type = '[Schedule] Set device to schedule create object';

  constructor(public device: number, public name: string) {
  }
}

export class PlaylistToScheduleCreate {
  static readonly type = '[Schedule] Set playlist to schedule create object';

  constructor(public playlist: number, public description: string, public name: string) {
  }
}

export class MediaToScheduleCreate {
  static readonly type = '[Schedule] Set media and playlist name to schedule create object';

  constructor(public media: IPlaylistMedia[], public playlistName: string) {
  }
}

export class SetActiveSchedule {
  static readonly type = '[Schedule] Set active schedule';

  constructor(public schedule: IDeviceArea[]) {
  }
}

export class SetTimeToNewSchedule {
  static readonly type = '[Schedule] Set time to new schedule';

  constructor(
    public payload: {
      startLocal: string,
      endLocal: string,
      endLocalTimeStamp: string,
      scheduleType: 'period' | 'allday' | 'repetetive' | 'constant' | null,
      repetition: string | null
    }
  ) {
  }
}

export class CleanScheduleToCreateData {
  static readonly type = '[Schedule] Clean schedule to create data';

  constructor() {
  }
}

export class CreateEvent {
  static readonly type = '[Schedule] Create event';
}

export class DeleteEventAreaDevice {
  static readonly type = '[Schedule] Delete event device';

  constructor(public id: number) {
  }
}

export class DeleteEventAreaGroup {
  static readonly type = '[Schedule] Delete event group';

  constructor(public id: number) {
  }
}

export class CleanSearchParamSchedule {
  static readonly type = '[Schedule] Clean search param';
}

export class GetSelectedDeviceScheduleById {
  static readonly type = '[Schedule] Get selected schedule device by Id';

  constructor(public id: number) {
  }
}

export class GetSelectedGroupScheduleById {
  static readonly type = '[Schedule] Get selected schedule group by Id';

  constructor(public id: number) {
  }
}

export class TurnOnEditMode {
  static readonly type = '[Schedule] Turn on edit mode for schedule';
}

export class TurnOffEditMode {
  static readonly type = '[Schedule] Turn off edit mode for schedule';
}
